export const trackLead = (contentName) => {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'Lead', { content_name: contentName });
  }
};
